import {
  Container,
  Row,
  Col,
  Card,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";
import styles from "./styles.module.scss";
import React, { useState } from "react";

export const Faq = ({
    className = "",
    title,
    items = []
  }) => {
    const [open, setOpen] = useState("");
  
    const toggle = (id) => {
      setOpen(open === id ? undefined : id);
    };
  
    return (
      <section className={`${styles.root} ${className}`}>
          <Card
            className="border-0 rounded-0 bg-black text-white pt-2 pb-5 text-center"
            id=""
          >
            <Container>
              <Row>
                <Col md={12} className="pt-4">
                  <p className="post-title fs-4">
                    <strong>{title}</strong>
                  </p>
                  <Accordion open={open} toggle={toggle} flush>
                    {items.map((item, itemIndex, index) => {
                      const accId = `${index}-${itemIndex}`;
                      return (
                        <AccordionItem key={accId}>
                          <AccordionHeader targetId={accId} tag={item.tag ?? "h5"} className="faq-s">
                            <strong>{item.title}</strong>
                          </AccordionHeader>
                          <AccordionBody accordionId={accId}>
                            {item.description && (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.description,
                                }}
                              />
                            )}
                          </AccordionBody>
                        </AccordionItem>
                      );
                    })}
                  </Accordion>
                </Col>
              </Row>
            </Container>
          </Card>
      </section>
    );
  };
  
export default Faq;




                            {/* {post.button_label ? (
                                <div className="mt-4">
                                    <Link href={post.button_link}>
                                        <a className="primaryBtn no-arrow">
                                            {post.button_label}
                                        </a>
                                    </Link>
                                </div>
                            ) : (
                            <></>
                            )} */}
